export default {
    namespaced: true,
    state: {
        mainPart: null // 缓存有声视频识别主体信息
        // {
        //     url: '',
        //     mainInfo: {}
        // }
    },
    mutations: {
        updateMainPart(state, value) {
            state.mainPart = value;
        }
    }
};
